import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import { useEffect } from 'react';
import { cn } from '@/lib/utils';

export interface DataTableRowViewField {
  field: string;
  label: string;
  value: string;
}

interface DataTableRowViewDialogProps {
  fields: DataTableRowViewField[];
  onClose: () => void;
}

export function DataTableRowViewDialog({ fields, onClose }: DataTableRowViewDialogProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div
      className='fixed inset-0 z-[1390] flex items-center justify-center bg-black/30 p-4'
      role='dialog'
      aria-modal='true'
      aria-label='Xem dữ liệu'
      onMouseDown={event => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className='flex max-h-[80vh] w-full max-w-3xl flex-col overflow-hidden rounded-md border bg-white shadow-xl'>
        <div className='flex h-11 shrink-0 items-center justify-between border-b bg-main px-4 text-main-foreground'>
          <h2 className='text-sm font-semibold'>Xem dữ liệu</h2>
          <button
            type='button'
            aria-label='Đóng'
            className='rounded p-1 hover:bg-white/15 focus:outline-none focus:ring-2 focus:ring-white/70'
            onClick={onClose}
          >
            <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-5' />
          </button>
        </div>

        <div className='grid min-h-0 flex-1 grid-cols-1 gap-x-6 overflow-auto p-4 sm:grid-cols-2'>
          {fields.map(item => (
            <div
              key={item.field}
              className={cn('grid min-h-10 grid-cols-[minmax(120px,40%)_1fr] items-start gap-3 border-b py-2 text-sm')}
            >
              <span className='font-medium text-slate-600'>{item.label}</span>
              <span className='break-words text-slate-900'>{item.value || '—'}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
